import { AnomalSel, AnomalType } from "@/features/anomalies";

import React from "react";
import { Button, Card, Col, Modal, Row } from "antd";
import { useSelector } from "react-redux";


type Props = {
  severity: string;
  visible: boolean;
  setVisible: (e: boolean) => void;
}

export default ({visible, setVisible, severity}: Props) => {
  const anomal = useSelector(AnomalSel.anomalData);
  const anomalyDate = useSelector(AnomalSel.anomalyDate);

  return (
    <Modal
      title={severity.toUpperCase()[0] + severity.slice(1) + " Notification " + "(" + anomalyDate + ")"}
      visible={visible}
      width={820}
      onCancel={() => setVisible(false)}
      footer={[
        <Button key="return" onClick={() => setVisible(false)}>
          Return
        </Button>
      ]}
    >
      <div style={{ background: "#ECECEC", padding: "2%" }}>
        <Row gutter={20}>
          {severity.length > 0 &&
            classifyAnomalData(anomal[severity as keyof AnomalType.AnomalData]).map(e => (
              <Col span={12}>
                {e.map(ent => (
                  <Card
                    title={ent.companyName}
                    headStyle={{ color: "grey", fontSize: 18 }}
                    bordered={true}
                    style={{ width: "100%", marginTop: 10 }}
                    extra={
                      <p
                        style={{
                          fontSize: 20,
                          marginBottom: 0,
                          color: ent.color,
                          font: "strong"
                        }}
                      >
                        {ent.ticker}
                      </p>
                    }
                    hoverable={true}
                  >
                    <div style={{ marginLeft: "5%" }}>
                      <p>
                        <strong>Price: </strong>
                        {ent.price}
                      </p>
                      <p>
                        <strong>Exchange: </strong>
                        {ent.exchange}
                      </p>
                      <p>
                        <strong>
                          <u>Detection:</u>
                        </strong>
                      </p>
                      <ul style={{ marginLeft: -10, marginTop: -15 }}>
                        {ent.detection.map(dect => (
                          <li>{dect}</li>
                        ))}
                      </ul>
                    </div>
                  </Card>
                ))}
              </Col>
            ))}
        </Row>
      </div>
    </Modal>
  );

  function classifyAnomalData(data: AnomalType.CompanyDetails[]) {
    return [data.filter(e => e.color === "green"), data.filter(e => e.color === "red")];
  }
};
